import { render, staticRenderFns } from "./writeXaOutAndIn.vue?vue&type=template&id=87fc537c&scoped=true"
import script from "./writeXaOutAndIn.vue?vue&type=script&lang=js"
export * from "./writeXaOutAndIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fc537c",
  null
  
)

export default component.exports